import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getArts } from "../../../../actions/arts";
import ArtFormSearchForm from "./artFormSearchForm";
import { getFormPermissionsByRole } from "../../../../actions/forms";

const initialValues = {
  art: "",
};

const ArtFormSearchFormContainer = ({ }) => {
  const dispatch = useDispatch();
  const art = useSelector((state) => state.arts);

  const loading = art.isFetching;

  useEffect(() => {
    dispatch(getArts());
  }, []);

  const handleSubmitSearch = (values) => {
    dispatch(getFormPermissionsByRole(values.art));
  }

  return <ArtFormSearchForm
    initialValues={initialValues}
    loading={loading}
    arts={art.list}
    handleSubmitSearch={handleSubmitSearch}
  />;
};

export default ArtFormSearchFormContainer;